import React, { useState } from 'react';
import PropTypes from 'prop-types';
import EmailInput from '../SignUp/EmailInput';
import { HelpBlock, Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { resetEmailError } from '../../redux/modules/auth';
import styles from './ExpiredBriefDetailsSignUp.module.scss';
import { trackEvent } from '../../helpers/Analytics';
import { useDispatch } from 'react-redux';
import ButtonWithLoader from '../ButtonWithLoader/ButtonWithLoader';

const ExpiredBriefDetailsSignUp = ({ briefRole, loggedIn }) => {
  const [email, setEmail] = useState();
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setEmailError('');
    dispatch(resetEmailError());
  };

  const handleApply = () => {
    if (!email) {
      setEmailError('Please enter your email.');
      return;
    }

    if (!emailError) {
      setLoading(true);
      trackEvent('user-clicks-on-expired-job-signup');
      window.location.href = `/signup?email=${email}&type=seller`;
      setLoading(false);
    }
  };

  const role = briefRole ? `${briefRole} ` : '';

  return (
    <>
      <Panel className={styles.container}>
        <h2 className={styles.heading}>No longer accepting applications</h2>
        {!loggedIn ? (
          <>
            <p className={styles.subHeading}>
              {`Get instant notifications for new ${role} jobs. Enter your email:`}
            </p>
            <div className={styles.signUpContainer}>
              <div className={styles.inputContainer}>
                <EmailInput
                  type="email"
                  placeholder="e.g. name@company.com"
                  styles={styles}
                  disabled={false}
                  value={email}
                  onChange={(event) => handleEmailChange(event)}
                  className={styles.input}
                  isInPost={false}
                  resetContinue={() => {
                    return;
                  }}
                />
              </div>
              <ButtonWithLoader
                onClick={() => handleApply()}
                bsStyle="primary"
                disabled={loading}
                style={{ minWidth: 75 }}
                loading={loading}
                text="Notify me"
              />
            </div>
          </>
        ) : (
          <p className={styles.subHeading}>
            Get instant notifications for new jobs. Update your{' '}
            <Link to="/settings#notifications">notification settings</Link>.
          </p>
        )}
        {emailError && (
          <HelpBlock className={styles.emailDanger}>{emailError}</HelpBlock>
        )}
      </Panel>
    </>
  );
};

ExpiredBriefDetailsSignUp.propTypes = {
  briefRole: PropTypes.string,
};

export default ExpiredBriefDetailsSignUp;
